<template>
  <div class="info">
    <div class="container">
      <h2 class="info__title">Что входит в&nbsp;итоговую сумму</h2>
      <div class="info__wrapper" :class="'info-slide-' + this.activeSlideIndex">
        <div class="info__items" :class="{ swiper: !isDesktop }" ref="swiper">
          <div :class="{ 'swiper-wrapper': !isDesktop }">
            <article class="info-item js-feature-item" ref="featureItem" :class="{ 'swiper-slide': !isDesktop }">
              <div class="info-item__content">
                <span class="info-item__action">Экономия №1</span>
                <h2 class="info-item__title">
                  Быстрое добавление<br />
                  резюме в&nbsp;базу
                </h2>
                <p class="info-item__text">
                  Экономия на&nbsp;сохранении каждым рекрутером
                  <span class="nowrap">{{
                    this.pluralize(this.params.resume_per_day, ['нового', 'новых', 'новых'])
                  }}</span>
                  резюме в&nbsp;день&nbsp;&mdash; Хантфлоу прикрепит их&nbsp;к&nbsp;вакансии и&nbsp;проверит
                  на&nbsp;дубликаты
                </p>
              </div>
            </article>
            <article class="info-item js-feature-item" ref="featureItem" :class="{ 'swiper-slide': !isDesktop }">
              <div class="info-item__content">
                <span class="info-item__action">Экономия №2</span>
                <h2 class="info-item__title">
                  Быстрая отправка<br />
                  резюме заказчикам
                </h2>
                <p class="info-item__text">
                  Экономия на&nbsp;отправке каждым рекрутером
                  {{ this.params.mail_per_day }} резюме заказчикам в&nbsp;день и&nbsp;добавлении обратной связи
                  по&nbsp;кандидатам в&nbsp;историю работы
                </p>
              </div>
            </article>
            <article class="info-item js-feature-item" ref="featureItem" :class="{ 'swiper-slide': !isDesktop }">
              <div class="info-item__content">
                <span class="info-item__action">Экономия №3</span>
                <h2 class="info-item__title">
                  Назначение интервью<br />
                  &laquo;под ключ&raquo;
                </h2>
                <p class="info-item__text">
                  Экономия на&nbsp;назначении каждым рекрутером
                  {{ this.params.cal_per_day }}&nbsp;интервью в&nbsp;день&nbsp;&mdash; Хантфлоу внесет
                  их&nbsp;в&nbsp;календарь с&nbsp;бронированием переговорки и&nbsp;прикрепит к&nbsp;событию резюме
                  со&nbsp;скрытием зарплаты
                </p>
              </div>
            </article>
            <article class="info-item js-feature-item" ref="featureItem" :class="{ 'swiper-slide': !isDesktop }">
              <div class="info-item__content">
                <span class="info-item__action">Экономия №4</span>
                <h2 class="info-item__title">
                  Письма и&nbsp;сообщения<br />
                  кандидатам в&nbsp;один клик
                </h2>
                <p class="info-item__text">
                  Экономия на&nbsp;отправке каждым рекрутером
                  <span>{{
                    this.pluralize(this.params.mail_tpl_per_day, [
                      'первичного письма',
                      'первичных писем',
                      'первичных писем',
                    ])
                  }}</span>
                  и&nbsp;сообщений кандидатам в&nbsp;день&nbsp;по&nbsp;заранее заданному шаблону
                </p>
              </div>
            </article>
          </div>
          <div class="swiper-pagination"></div>
        </div>
        <div class="info__chart-container" ref="chartContainer">
          <div class="info__chart">
            <svg width="490" height="490" viewBox="0 0 490 490" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M323.404 29.1792C274.567 11.4374 221.156 10.7839 171.899 27.3257C122.642 43.8674 80.4521 76.6263 52.2227 120.249"
                stroke="#F1F1F1"
                stroke-width="28"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M413.35 401.154C436.807 375.865 454.265 345.616 464.428 312.655C474.591 279.693 477.197 244.865 472.053 210.758C466.91 176.651 454.148 144.14 434.716 115.642C415.285 87.1434 389.682 63.3887 359.81 46.1423"
                stroke="#F1F1F1"
                stroke-width="28"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M84.2705 408.987C123.547 447.484 175.336 470.604 230.218 474.145C285.101 477.685 339.431 461.41 383.328 428.279"
                stroke="#F1F1F1"
                stroke-width="28"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M31.1839 161.283C17.5394 196.132 12.6195 233.787 16.8524 270.972C21.0854 308.156 34.3429 343.742 55.471 374.632"
                stroke="#F1F1F1"
                stroke-width="28"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div>
              <span class="info__price">{{ perYear(this.value.resume.money, true) }} ₽</span>
              <span class="info__price">{{ perYear(this.value.mail.money, true) }} ₽</span>
              <span class="info__price">{{ perYear(this.value.cal.money, true) }} ₽</span>
              <span class="info__price">{{ perYear(this.value.mail_tpl.money, true) }} ₽</span>
            </div>
          </div>
          <div class="info__pagination" id="infoPagination">
            <button type="button"></button>
            <button type="button"></button>
            <button type="button"></button>
            <button type="button"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import { EffectFade, Pagination as SwiperPagination } from 'swiper/modules';
Swiper.use([EffectFade, SwiperPagination]);
import { BREAKPOINTS } from '~scripts/core/breakpoints';
import { pluralize } from '~scripts/core/helpers';

const numFormat = new Intl.NumberFormat('ru-RU');

export default {
  name: 'CalculationResultInfo',
  props: {
    params: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isDesktop: true,
      activeSlideIndex: null,
    };
  },

  computed: {
    breakpoints() {
      return BREAKPOINTS;
    },
    mediaMd() {
      return window.matchMedia(`(max-width: ${this.breakpoints.mdMax})`);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.mediaMd.addEventListener('change', this.handleMediaChange);
      this.handleMediaChange(this.mediaMd);
    });
  },
  methods: {
    pluralize,
    handleinfoScroll() {
      const infoItems = Array.from(document.querySelectorAll('.js-feature-item'));
      const infoChartHeight = this.$refs.chartContainer.offsetHeight;
      const infoChartTop = this.$refs.chartContainer.getBoundingClientRect().top;
      const scrollThreshold = infoChartTop + infoChartHeight * 0.5;
      let index = -1;

      for (let i = infoItems.length - 1; i >= 0; i -= 1) {
        const item = infoItems[i];
        const itemTop = item.getBoundingClientRect().top;

        if (itemTop < scrollThreshold) {
          index = i;
          break;
        }
      }
      this.activeSlideIndex = index;
    },

    toggleSwiperSlider() {
      if (!this.isDesktop && !this.swiper) {
        this.$nextTick(() => {
          this.swiper = new Swiper(this.$refs.swiper, {
            slidesPerView: 1,
            effect: 'fade',
            loop: true,
            fadeEffect: {
              crossFade: true,
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            on: {
              init: () => {
                this.activeSlideIndex = 0;
              },
              slideChange: () => {
                if (this.swiper) {
                  this.activeSlideIndex = this.swiper.realIndex;
                }
              },
            },
          });
        });
      } else if (this.isDesktop && this.swiper) {
        this.$nextTick(() => {
          this.swiper.destroy();
          this.swiper = undefined;
        });
      }
    },
    handleMediaChange(event) {
      this.isDesktop = !event.matches;

      this.toggleSwiperSlider();

      if (this.isDesktop) {
        window.addEventListener('scroll', this.handleinfoScroll);
      } else {
        window.removeEventListener('scroll', this.handleinfoScroll);
      }
    },
    perYear(n, shouldFormat = false) {
      const result = Math.ceil(n * 12);
      if (shouldFormat) {
        return numFormat.format(result);
      }
      return result;
    },
  },
};
</script>

<style lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;
@use '~styles/components/texts' as texts;

.info {
  padding-bottom: 4rem;

  @include mixins.media(md) {
    padding-bottom: 8rem;
  }

  @include mixins.media(lg) {
    padding-bottom: 0;
  }

  &__title {
    @include mixins.font(3.4rem, 1.13, -0.34px);

    text-align: center;
    margin-top: 0rem;

    @include mixins.media(md) {
      @include mixins.font(6rem, 1.17, -0.9px);

      font-weight: vars.$fontWeightSolid;
      margin-bottom: 9rem;
      text-align: center;
    }

    @include mixins.media(lg) {
      margin-bottom: 5rem;
    }
  }

  &__pagination {
    display: none;

    @include mixins.media(lg) {
      position: absolute;
      top: 50%;
      left: -100%;
      display: inline-block;
      transform: translate(-2rem, -50%);
    }

    > button {
      display: block;
      padding: 0.6rem;
      opacity: 0.1;

      &:not(:last-child) {
        margin-bottom: 2.4rem;
      }

      &::after {
        @include mixins.size(1rem);

        display: block;
        background-color: vars.$colorBase;
        border-radius: 50%;
        content: '';
      }

      &.is-active {
        opacity: 1;
      }
    }
  }

  &__wrapper {
    position: relative;

    @include mixins.media(lg) {
      @include mixins.grid(2);

      align-items: flex-start;
    }
  }

  &__items {
    @include mixins.media(lg) {
      padding-left: 5.6rem;
    }
    @include mixins.media(xl) {
      padding-left: 9rem;
    }
  }

  &-item {
    position: relative;

    @include mixins.media(sm, max) {
      padding-top: 35rem;
    }

    @include mixins.media(lg) {
      display: flex;
      height: 600px;
      flex-direction: column;
      justify-content: center;
    }

    @for $i from 0 through 3 {
      &:nth-child(#{$i + 1}) {
        .info-item__action {
          $colors: #b6fcd2, #e2dffb, #ffe9a8, #b9f6ff;
          @include texts.text-highlight(nth($colors, $i + 1));
        }
      }
    }

    &__action {
      @include mixins.font(1.6rem, 1.55);

      color: #000;

      @include mixins.media(md) {
        @include mixins.font(2rem, 1.55);
      }
    }

    &__title {
      @include mixins.font(2.4rem, 1.14);

      font-weight: vars.$fontWeightMedium;
      margin-top: 1.4rem;

      @include mixins.media(md) {
        @include mixins.font(3.2rem, 1.2);

        margin-top: 1.6rem;
      }

      @include mixins.media(lg) {
        @include mixins.font(4rem, 1.2);
      }
    }

    &__text {
      margin-top: 0.8rem;
      opacity: 0.5;

      @include mixins.media(md) {
        @include mixins.font(1.8rem, 1.55);

        margin-top: 1.6rem;
        max-width: 35.7rem;
      }

      @include mixins.media(lg) {
        @include mixins.font(2.2rem, 1.55);

        max-width: 44rem;
      }
    }

    &__content {
      @include mixins.media(sm, max) {
        text-align: center;
      }
    }
  }

  &__chart {
    @include mixins.size(28rem);

    position: absolute;
    top: 4rem;
    right: 0;

    @include mixins.media(sm, max) {
      right: 50%;
      transform: translateX(50%);
    }

    @include mixins.media(md) {
      @include mixins.size(28rem);

      top: -2.5rem;
    }

    @include mixins.media(lg) {
      @include mixins.size(490px);

      top: initial;
      right: initial;
      position: relative;
      margin-left: auto;
    }

    svg {
      @include mixins.size(28rem);

      @include mixins.media(md) {
        @include mixins.size(28rem);
      }
      @include mixins.media(lg) {
        @include mixins.size(490px);
      }
    }

    path {
      @include mixins.media(md) {
        transition: 0.6s;
      }
    }
  }

  &__price {
    @include mixins.font(3.6rem, 1.25);

    position: absolute;
    white-space: nowrap;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: 0.5s;

    @include mixins.media(lg) {
      @include mixins.font(6rem, 1.25);

      color: #000;
    }
  }

  &__chart-container {
    @include mixins.media(lg) {
      position: sticky;
      display: flex;
      top: calc((100vh - 536px) / 2);
      height: 600px;
      flex-direction: column;
      justify-content: center;
      text-align: right;
    }
  }

  @for $i from 0 through 3 {
    &-slide-#{$i} {
      svg {
        path {
          &:nth-child(#{$i + 1}) {
            $colors: #1ddd6a, #aea8ff, #ffd95c, #42e6ff;
            stroke: nth($colors, $i + 1);
          }
        }
      }

      .info__pagination button {
        &:nth-child(#{$i + 1}) {
          opacity: 1;
        }
      }

      .info__price {
        &:nth-child(#{$i + 1}) {
          opacity: 1;
        }
      }
    }
  }

  .swiper-pagination {
    @include mixins.media(lg) {
      display: none;
    }
  }
}

.swiper {
  .swiper-pagination {
    margin-top: 3rem;
    position: relative;

    @include mixins.media(md) {
      margin-top: 6rem;
    }

    span.swiper-pagination-bullet {
      @include mixins.size(0.8rem);

      opacity: 1;
      background: #d9d9d9;

      @include mixins.media(md) {
        @include mixins.size(1.2rem);

        margin: 0 10px;
      }

      &-active {
        background: #1d1d1f;
      }
    }
  }
}
</style>
